<div class="input-with-revert d-flex align-items-center gap-2">
    @if (editMode()) {
        @if (isUserPicker()) {
            <span
                class="input-with-revert__control d-flex align-items-center gap-1"
                [ngClass]="overriddenClass"
                style="max-width: 250px"
            >
                <user-picker
                    class="flex-grow-1"
                    [currentContact]="userPickerContact"
                    [currentContactDisplay]="userDisplayValue()"
                    [inputClass]="overriddenClass"
                    [searchAllAssignable]="true"
                    [usersOnly]="true"
                    (contactSelected)="onUserSelected($event)"
                ></user-picker>
                <button
                    class="ace-btn has-icon btn-primary btn-danger"
                    style="margin: 0"
                    (click)="clearUser()"
                    tooltip="Clear Assigned User"
                >
                    <i class="fa fa-close"></i>
                </button>
            </span>
        } @else if (selectOptions()?.length) {
            <select
                class="input-with-revert__control form-select form-select-sm"
                style="max-width: 250px"
                [ngStyle]="customWidth() ? { 'width.px': customWidth(), flex: 'none' } : {}"
                [ngClass]="overriddenClass"
                [ngModel]="textValue"
                autocomplete="nope"
                (ngModelChange)="onTextInput($event)"
                (blur)="onTouched()"
            >
                @for (option of selectOptions(); track option) {
                    <option [value]="option.value">{{ option.name }}</option>
                }
            </select>
        } @else if (isDate()) {
            <weissman-datetime
                [ngClass]="overriddenClass"
                [inputDate]="dateValue!"
                (inputDateChange)="onDateInput($event)"
                (inputDateBlur)="onTouched()"
                [readOnly]="false"
                [dateOnly]="true"
            >
            </weissman-datetime>
        } @else if (isEngagementNumber()) {
            <span [ngClass]="overriddenClass" style="min-width: 95px">{{ value }}</span>
            <button
                class="input-with-revert__button ace-btn has-icon btn-primary"
                style="margin: 0 15px 0 0"
                (click)="lookupEngagement()"
                tooltip="Select Engagement Number"
            >
                <i class="fa fa-binoculars"></i>
            </button>
        } @else if (isNumber()) {
            <!-- Need to account for decimal point and percentage symbol in maxlength -->
            <input
                type="text"
                autocomplete="nope"
                class="input-with-revert__control form-control text-end"
                style="max-width: 250px"
                [ngStyle]="customWidth() ? { 'width.px': customWidth() } : {}"
                [attr.maxlength]="maxlength() + 1"
                [ngClass]="overriddenClass"
                [ngModel]="numberValue"
                (ngModelChange)="onTextInput($event)"
                (blur)="onTouched()"
                [min]="0"
                currencyMask
                [placeholder]="placeholder()"
                [options]="{
                    allowNegative: false,
                    prefix: isCurrency() ? '$' : '',
                    thousands: '',
                    precision: precision() ?? 0,
                }"
            />
        } @else if (isPercent()) {
            <span style="display: flex; align-items: center; gap: 5px; width: 250px">
                <input
                    type="text"
                    inputmode="decimal"
                    autocomplete="nope"
                    class="form-control text-end"
                    style="max-width: 250px"
                    [ngClass]="overriddenClass"
                    [value]="percentInputValue"
                    (input)="onPercentInput($any($event.target).value)"
                    (blur)="onTouched()"
                    [placeholder]="placeholder()"
                />
                %
            </span>
        } @else if (isBoolean()) {
            <select
                class="form-select form-select-sm"
                style="width: auto"
                [ngStyle]="customWidth() ? { 'width.px': customWidth() } : {}"
                [ngClass]="overriddenClass"
                [ngModel]="booleanValue == null ? '' : booleanValue.toString()"
                (ngModelChange)="onTextInput($event)"
                (blur)="onTouched()"
            >
                @if (hasUnknown()) {
                    <option value="">Unknown</option>
                }
                <option value="true">Yes</option>
                <option value="false">No</option>
            </select>
        } @else if (isTextArea()) {
            <textarea
                class="input-with-revert__control form-control"
                autocomplete="nope"
                [ngClass]="overriddenClass"
                style="max-width: 250px"
                [attr.maxlength]="maxlength()"
                rows="3"
                [value]="textValue"
                (input)="onTextInput($any($event.target).value)"
                (blur)="onTouched()"
                [placeholder]="placeholder()"
            ></textarea>
        } @else {
            <input
                type="text"
                autocomplete="nope"
                class="input-with-revert__control form-control form-control-sm"
                [style.max-width.px]="placeholder() === 'State' ? 40 : 250"
                [ngStyle]="customWidth() ? { 'width.px': customWidth() } : {}"
                [attr.maxlength]="maxlength()"
                [ngClass]="overriddenClass"
                [value]="textValue"
                (input)="onTextInput($any($event.target).value)"
                (blur)="onTouched()"
                [placeholder]="placeholder()"
            />
        }

        @if (valueDiffersFromOriginal) {
            <button
                class="input-with-revert__button ace-btn has-icon btn-primary btn-danger"
                [style.margin-bottom.px]="isTextArea() ? 47 : 0"
                style="margin: 0"
                (click)="revertToOriginal()"
            >
                <i class="fa fa-undo"></i>
            </button>
        } @else if (valueDiffersFromSystem) {
            <button
                class="input-with-revert__button ace-btn has-icon btn-primary"
                [style.margin-bottom.px]="isTextArea() ? 47 : 0"
                style="margin: 0"
                (click)="revertToSystem()"
            >
                <i class="fa fa-undo"></i>
            </button>
        } @else {
            <!-- dummy button to take up space -->
            <button class="input-with-revert__button ace-btn has-icon invisible" style="margin: 0">
                <i class="fa fa-undo"></i>
            </button>
        }
    } @else {
        @if (isUserPicker()) {
            <span class="input-with-revert__control" [ngClass]="overriddenClass">{{ userDisplayValue() }}</span>
        } @else if (isDate()) {
            <weissman-datetime
                class="input-with-revert__control"
                [ngClass]="overriddenClass"
                [inputDate]="dateValue!"
                [readOnly]="true"
                [dateOnly]="true"
            ></weissman-datetime>
        } @else if (selectOptions()?.length) {
            <span class="input-with-revert__control" [ngClass]="overriddenClass">{{ selectValue }}</span>
        } @else if (isNumber() && numberValue !== null) {
            <span class="input-with-revert__control" [ngClass]="overriddenClass">
                {{ isCurrency() ? '$' : '' }}{{ numberValue | number: numberDigitsInfo }}
            </span>
        } @else if (isPercent() && numberValue !== null) {
            <span class="input-with-revert__control" [ngClass]="overriddenClass">
                {{ numberValue | number: numberDigitsInfo }}%
            </span>
        } @else if (isBoolean()) {
            <span class="input-with-revert__control" [ngClass]="overriddenClass">
                {{ booleanValue ? 'Yes' : booleanValue === false ? 'No' : hasUnknown() ? 'Unknown' : '' }}
            </span>
        } @else {
            <span class="input-with-revert__control" [ngClass]="overriddenClass" style="word-break: break-word">
                {{ value }}
            </span>
        }
    }
</div>
